import React, { useCallback, useEffect, useState } from "react";

export function hideCaptcha() {
  return globalThis.ENVS?.RECAPTCHA_SITE_KEY == null;
}

export function ignoreCaptchaResponse() {
  return hideCaptcha() || !!globalThis.ENVS?.SKIP_CAPTCHA_CHECK;
}

export function useCaptcha() {
  const [showCaptchaError, setShowCaptchaError] = useState(false);

  const loadExternalCaptcha = useCallback(() => {
    const captchaSiteKey = globalThis.ENVS?.RECAPTCHA_SITE_KEY;

    if (captchaSiteKey && !hideCaptcha()) {
      document.getElementById("g-recaptcha").dataset.sitekey = captchaSiteKey;
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [globalThis.ENVS?.RECAPTCHA_SITE_KEY]);

  useEffect(() => {
    loadExternalCaptcha();
  }, [loadExternalCaptcha]);

  const getCaptchaResponse = useCallback(() => {
    const captaResponseNodes = document.getElementsByClassName(
      "g-recaptcha-response"
    );
    const responseCodes = Array.from(captaResponseNodes)
      .map((e) => e?.value?.trim())
      .filter((v) => v != "");

    if (responseCodes.length > 0) {
      if (responseCodes.length > 1) {
        console.warn(`${responseCodes.length} captcha responses`);
      }
      return responseCodes.at(-1);
    }
    return "";
  }, []);

  const validateCaptchaCompletion = useCallback(() => {
    if (ignoreCaptchaResponse()) {
      return true;
    }

    var hasCaptchaResponse = getCaptchaResponse() !== "";
    setShowCaptchaError(!hasCaptchaResponse);
    return hasCaptchaResponse;
  }, [getCaptchaResponse]);

  return {
    validateCaptchaCompletion,
    getCaptchaResponse,
    showCaptchaError,
  };
}

export default function Capthcha({ showErrorMessage }) {
  if (hideCaptcha()) {
    return null;
  }
  return (
    <div style={{ marginBottom: "20px" }}>
      <div
        className="g-recaptcha margin-top-2"
        data-sitekey={globalThis?.ENVS?.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
        id="g-recaptcha"
      ></div>
      <div
        className="text-small margin-bottom-2"
        style={{ color: "#d12" }}
        hidden={!showErrorMessage}
      >
        <sdx-icon
          icon-name="icon-exclamation-mark"
          aria-hidden="true"
          class="hydrated"
          size="2"
        ></sdx-icon>
        {"The CAPTCHA must be solved"}
      </div>
    </div>
  );
}
